import React, { useEffect, useRef, useState } from 'react';
import { useReducedMotion } from 'framer-motion';
import { LEAD_TICKER } from '../data/site';

/**
 * A hairline strip under the hero: a slow loop of fictional lead events.
 * It starts on entry and pauses off-screen or on hover. Reduced
 * motion renders a single static row.
 */
const LeadTicker: React.FC = () => {
  const reduced = useReducedMotion();
  const tickerRef = useRef<HTMLDivElement>(null);
  const [started, setStarted] = useState(false);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const node = tickerRef.current;
    if (reduced || !node) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setInView(entry.isIntersecting);
        if (entry.isIntersecting) setStarted(true);
      },
      { threshold: 0.01 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [reduced]);

  const items = reduced ? LEAD_TICKER : [...LEAD_TICKER, ...LEAD_TICKER];
  const trackClass = [
    'ticker__track',
    reduced ? 'ticker__track--still' : '',
    started ? 'ticker__track--animate' : '',
    started && inView ? 'ticker__track--running' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className="ticker" aria-label="Recent activity examples" ref={tickerRef}>
      <div className={trackClass}>
        {items.map((line, i) => (
          <span className="ticker__item" key={`${line}-${i}`}>
            {line}
          </span>
        ))}
      </div>
    </div>
  );
};

export default React.memo(LeadTicker);
